import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const PairingInfo = ({ pairing }) => {
  const { t } = useTranslation();
  const [data, setData] = React.useState({ name: "", table: "" });

  React.useEffect(() => {
    if (pairing) {
      setData({
        name: pairing.person?.profile?.firstName,
        table: pairing.table,
        round: pairing.round,
      });
    }
  }, [pairing]);

  if (!data.name && !data.round) {
    return <></>;
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div>
        <Typography
          gutterBottom
          variant="h5"
          align="center"
          style={{ fontWeight: "bold" }}
        >
          {data?.name}
        </Typography>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-around",
        }}
      >
        {pairing?.breakRound ? (
          <></>
        ) : (
          <Typography>
            {t("event.round.label")}: {data?.round ? data.round : ""}
          </Typography>
        )}
        {(pairing?.noPairing || pairing?.breakRound) ? (
          <></>
        ) : (
          <Typography>
            {t("event.table.label")}: {data?.table ? data.table : ""}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default PairingInfo;
